import notificationsAPI from '@/app/apis/main/notifications/notifications-api.js';

export default {
	/**
	 * @return {object} notifications list
	 * @param {*} tableDetails - Contains pagination data
	 */
	async getNotificationList(tableDetails) {
		return notificationsAPI.getNotificationList(tableDetails);
	},

	/**
	 * @param {*} notificationDetails - Contains pagination data
	 */
	async postNotification(notificationDetails) {
		return notificationsAPI.postNotification(notificationDetails);
	},

	async deleteNotification(id) {
		return notificationsAPI.deleteNotification(id);
	},

	/**
	 * @return {object} notifications list
	 * @param {tableDetails}  - Contains pagination data
	 */
	async getNotification(tableDetails) {
		return notificationsAPI.getNotification(tableDetails);
	},

	/**
	 * @return {object} notifications details
	 * @param {id}  - Notification id
	 */
	 async getNotificationById(id) {
		return notificationsAPI.getNotificationById(id);
	},

	/**
	 * @return {object} admin notifications list
	 * @param {*} tableDetails - Contains pagination data
	 */
	 async getAdminNotificationList(tableDetails) {
		return notificationsAPI.getAdminNotificationList(tableDetails);
	},

	async putNotification(id) {
		return notificationsAPI.putNotification(id);
	},

	/**
	 * Marks all admin notifications as read.
	 * @returns {Promise} A promise that resolves when the operation is complete.
	*/
	async markAllAsReadNotifications() {
        return notificationsAPI.markAllAsReadNotifications();
    }
}